import {
  formatPropertyAddressLine,
  formatPropertyAddressStreetLine,
  resolvePropertyZipcode,
} from "@/src/modules/properties/lib/property-address";

type SafelistingHouseholdDisplaySource = {
  name?: string | null;
  number?: string | number | null;
  street?: string | null;
  unit_number?: string | null;
  city?: string | null;
  state?: string | null;
  zipcode?: string | null;
  zip_code?: string | number | null;
  country?: string | null;
};

type SafelistingPropertySummarySource = SafelistingHouseholdDisplaySource & {
  name?: string | null;
};

function hasSafelistingHouseholdAddressParts(
  household: SafelistingHouseholdDisplaySource,
): boolean {
  return Boolean(
    formatPropertyAddressStreetLine(household) ||
      household.unit_number?.trim() ||
      household.city?.trim() ||
      household.state?.trim() ||
      resolvePropertyZipcode(household),
  );
}

/** Full address line — same helper as resident home welcome card. */
export function getSafelistingHouseholdAddressLine(
  household: SafelistingHouseholdDisplaySource | null | undefined,
): string | null {
  if (!household) return null;

  if (hasSafelistingHouseholdAddressParts(household)) {
    const address = formatPropertyAddressLine(household).trim();
    return address || null;
  }

  const name = household.name?.trim();
  return name || null;
}

/** `Property name · address` — muted third line on resident home. */
export function getSafelistingPropertySummary(
  property: SafelistingPropertySummarySource | null | undefined,
): string | null {
  if (!property) return null;

  const name = property.name?.trim() || null;
  const address = hasSafelistingHouseholdAddressParts(property)
    ? formatPropertyAddressLine(property).trim()
    : null;
  const summary = [name, address].filter(Boolean).join(" · ");
  return summary || null;
}

/** Single-line label for datatable / mobile feed (address or name). */
export function getSafelistingHouseholdDisplay(
  household: SafelistingHouseholdDisplaySource | null | undefined,
): string {
  return getSafelistingHouseholdAddressLine(household) ?? "—";
}
